import { connect } from 'react-redux'
import {
  pageRenderLeft,
  setSelectedDeals,
  clearSelectedDeals,
  setSignUpModalIsOpen,
  setUserRolesModalIsOpen
} from 'redux/actions'
import { hasContentType } from 'redux/actions/user'
import { MARKETS_ACCESS_CONTENT } from 'constants/access-roles'
import ListDeals from 'pages/mwlistdeals/Main'

const mapStateToProps = state => ({
  flavour: state.layout.flavour,
  selectedDeals: state.dealwatch.selectedDeals,
  selectedDealType: state.dealwatch.selectedDealType,
  isLogged: state.user.isLogged,
  hasMarketsAccess: hasContentType(state.user.accessRoles, MARKETS_ACCESS_CONTENT),
  browser: state.layout.browser,
  isMobile: state.layout.deviceType.isMobile
})

const mapDispatchToProps = dispatch => ({
  pageRenderLeft: component => dispatch(pageRenderLeft(component)),
  setSelectedDeals: ({ select, deselect, dealType }) => dispatch(setSelectedDeals({ select, deselect, dealType })),
  clearSelectedDeals: () => dispatch(clearSelectedDeals()),
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen)),
  setUserRolesModalIsOpen: isOpen => dispatch(setUserRolesModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(ListDeals)
